// extracted by mini-css-extract-plugin
module.exports = {"round-background":"CarouselIcon_round-background__Hs_lg"};